wbApp.directive('wbAccountingBookCombo', ['$timeout', '$translate', 'accountingBookSvc',
    function ($timeout, $translate, accountingBookSvc) {
        function formatResult(model) {
            if (!model) { return; }

            if (model.isDefault) {
                return "<div class='row' style='width:100%'>" +
                           "<div class='col-md-5'><strong>" + model.name + "</strong></div>" +
                           "<div class='col-md-7'><strong>" + (model.subjectName || '') + "</strong></div>" +
                       "</div>";
            } else {
                return "<div class='row' style='width:100%'>" +
                           "<div class='col-md-5'>" + model.name + "</div>" +
                           "<div class='col-md-7'>" + (model.subjectName || '') + "</div>" +
                       "</div>";
            }
        }

        function formatSelection(model) {
            return model.name;
        }

        return {
            restrict: 'A',
            require: '?ngModel',
            priority: 1,
            link: function (scope, elm, attrs, ctrl) {

                var models = accountingBookSvc.getAllAsync();

                $timeout(function () {

                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_ACCOUNTING_BOOK'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: false,
                        minimumResultsForSearch: -1,
                        data: models
                    });

                    ctrl.$render();
                });

                ctrl.$parsers.unshift(function (viewValue) {
                    if (!viewValue) {
                        return 0;
                    } else {
                        return parseInt(viewValue);
                    }
                });

                ctrl.$formatters.unshift(function (value) {
                    if (!value) {
                        return "";
                    } else {
                        return value + "";
                    }
                });

                ctrl.$render = function () {
                    models.$promise.then(function () {
                        $(elm).select2('val', ctrl.$viewValue);
                    });
                }

                elm.on('change', function (e) {
                    scope.$apply(function () {
                        ctrl.$setViewValue(e.val);
                    });
                });

                elm.bind("$destroy", function () {
                    elm.select2("destroy");
                });

                attrs.$observe('readonly', function (value) {
                    elm.select2('readonly', !!value);
                });
            }
        }
    }]);    